import type {
  UnknownElement,
  ValueType,
} from '@/features/legends/editor/legend-document'

/**
 * A scoping template: how to answer the legend's questions for a job from
 * the template's data.
 */
export interface Template {
  id?: string
  name?: string
  mappings?: TemplateMapping[]
  dataSources?: TemplateDataSource[]
}

/**
 * How a template answers one question.
 */
export interface TemplateMapping {
  id?: string
  questionId?: string
  kind: TemplateMappingKind
}

/**
 * Answered by a formula over the template's data, or by asking.
 */
export type TemplateMappingKind =
  { type: 'Expr'; expr?: string } | { type: 'Manual' } | UnknownElement

/**
 * Data a template's formulas can read.
 */
export interface TemplateDataSource {
  id: string
  valueType: ValueType
}

/**
 * The data a template's formulas can read, per job being scoped.
 */
export const templateDataSources: TemplateDataSource[] = [
  { id: 'CLIENT_NAME', valueType: { type: 'String' } },
  { id: 'CLIENT_NUMBER', valueType: { type: 'String' } },
  { id: 'TOTAL_ASSETS', valueType: { type: 'Number' } },
  { id: 'GROSS_SALES', valueType: { type: 'Number' } },
  { id: 'PAGE_COUNT', valueType: { type: 'Number' } },
  { id: 'FORMS', valueType: { type: 'List', itemType: { type: 'String' } } },
  { id: 'STATES', valueType: { type: 'List', itemType: { type: 'String' } } },
  { id: 'K1', valueType: { type: 'List', itemType: { type: 'String' } } },
  {
    id: 'FLOW_THROUGH_K1',
    valueType: { type: 'List', itemType: { type: 'String' } },
  },
  { id: 'RENTALS', valueType: { type: 'List', itemType: { type: 'String' } } },
]
